<template>
  <div
    class="finishing-popup-wrap mini"
    id="finishing-popup-wrap"
    v-if="$store.state.showFinishingOptionsPopup"
    v-on:click="hidePopup()">
    <div
      class="finishing-popup-content"
      v-on:click="$event.stopPropagation()">
      <div class="in-action">
        <img src="./../../assets/images/coping-skirting.jpg"/>
      </div>
      <article>
        <header>
          <h4>{{ header }}</h4>
        </header>
        <section>
          <p v-for="(section, index) in bodySections" :key="`fop-body-${index}`">
            {{ section }}
          </p>
        </section>
        <button
          class="mobile-close"
          v-on:click="hidePopup()">
          <img src="./../../assets/icons/close.svg"/>
        </button>
      </article>
      <button
        class="desktop-close"
        v-on:click="hidePopup()"
        aria-label="Close">
        <img aria-hidden="true" src="./../../assets/icons/close.svg"/>
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'FinishingOptionPopup',
  watch: {
    $route () {
      if (this.showPopup) {
        this.hidePopup();
      }
    }
  },
  computed: {
    ...mapGetters(['getT']),
    bodySections() {
      const body = this.getT?.static?.finishing_option_popup[0]?.section;
      if (!body || !body.length) return ["Sorry, we can't find the information you're looking for..."];
      return body.split('\n').filter(obj => !!obj.length);
    },
    header() {
      const header = this.getT.static.finishing_option_popup[0].header;
      return header;
    },
  },
  methods: {
    hidePopup() {
      this.$store.commit('hideFinishingOptionsPopup');
    }
  },
}
</script>
<style scoped lang="scss">
$z-index: 61;

.finishing-popup-wrap {
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  button.desktop-close {
    display: none;
  }
  .finishing-popup-content {
    position: relative;
    width: 100%;
    max-width: 50em;
    height: 100%;
    background-color: $deep-navy;
    overflow: hidden;
    // Mobile - horizontal orientation
    //@media only screen and (max-width: 1020px) and (min-aspect-ratio: 5/4) {
    @media only screen and (max-width: #{ $xl - 1px }) {
      max-width: 100%;
    }
    .in-action {
      position: absolute;
      z-index: $z-index;
      top: 0;
      width: 100%;
      max-width: 40%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    article {
      position: absolute;
      z-index: $z-index;
      top: 0;
      height: 100%;
      width: 100%;
      padding: 1em;
      @media only screen and (max-width: #{ $xl - 1px }) {
        background-color: $deep-navy;
      }
      &::after {
        content: '';
        position: absolute;
        display: block;
        width: 100%;
        height: 6rem;
        bottom: 0;
        background: linear-gradient(rgba(16, 28, 48, 0), rgba(16, 28, 48, 0.7));
      }
      header {
        max-width: calc(100% - 5.25em);
        padding: .5em 0;
        h4 {
          padding-top: .5em;
          color: white;
          text-transform: uppercase;
          font-size: 1.2rem;
          letter-spacing: 2.24px;
        }
        @media only screen and (min-width: #{ $xl }) {
          max-width: 100%;
        }
      }
      section {
        overflow-y: auto;
        height: 100%;
        padding: .5em 0 9em 0;
        p {
          margin: 1em 0;
          color: white;
        }
        p.muted {
          margin: 1em 0 12em 0;
          color: $teal;
        }
      }
      button.mobile-close {
        position: absolute;
        z-index: 62;
        // Center content - safari won't size svg corrently for some reason
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: $z-index + 1;
        bottom: 1em;
        left: calc(50% - 2em);
        width: 4em;
        height: 4em;
        padding: 1em;
        border-radius: 50%;
        cursor: pointer;
        img {
          max-width: 1.5em;
          max-height: 1.5em;
        }
      }
    }
  }

  @media #{$desktop} {
    position: relative;
    z-index: 11;
    backdrop-filter: blur(5px);
    background-color: rgba(0,0,0,0.3);
    animation: fade-in-popup 400ms ease-out;
    @keyframes fade-in-poup {
      from { background-color: transparent; }
      to { background-color: rgba(0,0,0,0.3); }
    }
    .finishing-popup-content {
      width: 80em;
      max-width: calc(100% - 10em);
      height: unset;
      display: flex;
      align-items: center;
      box-shadow: 0 0 30px 10px rgba(0,0,0,0.5);
      button.desktop-close {
        position: absolute;
        z-index: 62;
        top: 1em;
        right: 0;
        display: block;
        background: transparent;
        border: none;
        opacity: .5;
        img {
          width: 1.3em;
        }
        &:hover {
          opacity: 0.8;
        }
      }
      .in-action {
        position: relative;
        width: 50%;
        max-width: 50%;
        min-width: unset;
      }
      .in-action, .in-action img {
        min-height: 40em;
        animation: none !important;
        overflow: hidden;
      }
      .in-action img {
        display: inherit;
      }
      article {
        width: 50%;
        position: unset; 
        padding: 4em;
        display: flex;
        flex-direction: column;
        justify-items: center;
        section {
          padding-bottom: 0;
          p.muted {
            margin: 1em 0;
          }
        }
        button.mobile-close {
          display: none;
        }
      }
    }
  }
}
</style>
